export const PencilIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8617 5.99746L16.5492 4.30996C17.2814 3.57773 18.7678 4.27851 19.5 5.01074C20.2322 5.74298 20.7328 7.02923 20.0006 7.76146L14.6913 13.0708L9.38197 18.3801C8.95771 18.8044 8.45398 19.1384 7.90124 19.3641C7.62893 19.4753 7.3385 19.5318 7.04735 19.5736L4 20.0108L4.79978 16.8259C5.01323 16.1094 5.40185 15.4573 5.93052 14.9286L14.8617 5.99746ZM14.8617 5.99746L18.2998 9.43563"
        stroke="#A6A6AD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CellEditedIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5121 14L11.7804 25L6.90234 20"
        stroke="#089520"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23146_208888)">
        <path
          opacity="0.12"
          d="M1.66675 4.33464C1.66675 3.40121 1.66675 2.9345 1.8484 2.57798C2.00819 2.26438 2.26316 2.00941 2.57676 1.84962C2.93328 1.66797 3.39999 1.66797 4.33341 1.66797H10.6667C11.6002 1.66797 12.0669 1.66797 12.4234 1.84962C12.737 2.00941 12.992 2.26438 13.1518 2.57798C13.3334 2.9345 13.3334 3.40121 13.3334 4.33464V10.668C13.3334 11.6014 13.3334 12.0681 13.1518 12.4246C12.992 12.7382 12.737 12.9932 12.4234 13.153C12.0669 13.3346 11.6002 13.3346 10.6667 13.3346H4.33341C3.39999 13.3346 2.93328 13.3346 2.57676 13.153C2.26316 12.9932 2.00819 12.7382 1.8484 12.4246C1.66675 12.0681 1.66675 11.6014 1.66675 10.668V4.33464Z"
          fill="black"
        />
        <path
          d="M6.66675 13.3346V15.668C6.66675 16.6014 6.66675 17.0681 6.8484 17.4246C7.00819 17.7382 7.26316 17.9932 7.57676 18.153C7.93328 18.3346 8.39999 18.3346 9.33341 18.3346H15.6667C16.6002 18.3346 17.0669 18.3346 17.4234 18.153C17.737 17.9932 17.992 17.7382 18.1518 17.4246C18.3334 17.0681 18.3334 16.6014 18.3334 15.668V9.33464C18.3334 8.40121 18.3334 7.9345 18.1518 7.57798C17.992 7.26438 17.737 7.00941 17.4234 6.84962C17.0669 6.66797 16.6002 6.66797 15.6667 6.66797H13.3334M4.33341 13.3346H10.6667C11.6002 13.3346 12.0669 13.3346 12.4234 13.153C12.737 12.9932 12.992 12.7382 13.1518 12.4246C13.3334 12.0681 13.3334 11.6014 13.3334 10.668V4.33464C13.3334 3.40121 13.3334 2.9345 13.1518 2.57798C12.992 2.26438 12.737 2.00941 12.4234 1.84962C12.0669 1.66797 11.6002 1.66797 10.6667 1.66797H4.33341C3.39999 1.66797 2.93328 1.66797 2.57676 1.84962C2.26316 2.00941 2.00819 2.26438 1.8484 2.57798C1.66675 2.9345 1.66675 3.40121 1.66675 4.33464V10.668C1.66675 11.6014 1.66675 12.0681 1.8484 12.4246C2.00819 12.7382 2.26316 12.9932 2.57676 13.153C2.93328 13.3346 3.39999 13.3346 4.33341 13.3346Z"
          stroke="#6C737F"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_23146_208888">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AnticipateDischargeDateIcon = () => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6.84998 11.0022C7.02617 10.5014 7.37395 10.079 7.83171 9.80998C8.28947 9.54095 8.82767 9.4426 9.35099 9.53237C9.87431 9.62213 10.349 9.89421 10.6909 10.3004C11.0329 10.7066 11.22 11.2207 11.2192 11.7517C11.2192 13.2506 8.97089 14 8.97089 14M9 17H9.01M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
      stroke="#6C737F"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActualDischargeDateIcon = () => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 15L8 17L12.5 12.5M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
      stroke="#107569"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlanOfCareIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.833 9.25H6.33301M7.83301 12.25H6.33301M12.333 6.25H6.33301M15.333 6.1V13.9C15.333 15.1601 15.333 15.7902 15.0878 16.2715C14.8721 16.6948 14.5279 17.039 14.1045 17.2548C13.6232 17.5 12.9931 17.5 11.733 17.5H6.93301C5.67289 17.5 5.04283 17.5 4.56153 17.2548C4.13816 17.039 3.79396 16.6948 3.57824 16.2715C3.33301 15.7902 3.33301 15.1601 3.33301 13.9V6.1C3.33301 4.83988 3.33301 4.20982 3.57824 3.72852C3.79396 3.30516 4.13816 2.96095 4.56153 2.74524C5.04283 2.5 5.67289 2.5 6.93301 2.5H11.733C12.9931 2.5 13.6232 2.5 14.1045 2.74524C14.5279 2.96095 14.8721 3.30516 15.0878 3.72852C15.333 4.20982 15.333 4.83988 15.333 6.1Z"
        stroke="#6366F1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="5"
      viewBox="0 0 4 5"
      fill="none"
    >
      <circle
        cx="2"
        cy="2.5"
        r="2"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="trash-01">
        <path
          id="Icon"
          d="M14.5294 5.7091V5.00322C14.5294 4.01489 14.5294 3.52073 14.3371 3.14323C14.1679 2.81118 13.8979 2.54122 13.5659 2.37203C13.1884 2.17969 12.6942 2.17969 11.7059 2.17969H10.2941C9.3058 2.17969 8.81164 2.17969 8.43415 2.37203C8.1021 2.54122 7.83213 2.81118 7.66294 3.14323C7.4706 3.52073 7.4706 4.01489 7.4706 5.00322V5.7091M9.23531 10.562V14.9738M12.7647 10.562V14.9738M3.05884 5.7091H18.9412M17.1765 5.7091V15.5915C17.1765 17.0739 17.1765 17.8152 16.888 18.3814C16.6342 18.8795 16.2292 19.2845 15.7312 19.5382C15.1649 19.8267 14.4237 19.8267 12.9412 19.8267H9.05884C7.57635 19.8267 6.8351 19.8267 6.26886 19.5382C5.77079 19.2845 5.36584 18.8795 5.11206 18.3814C4.82354 17.8152 4.82354 17.0739 4.82354 15.5915V5.7091"
          stroke="#F04438"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ManageTemplIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M13.5 0.3H3.5C2.00845 0.3 0.8 1.53381 0.8 3.04237V12.9576C0.8 14.4662 2.00845 15.7 3.5 15.7H13.5C14.9916 15.7 16.2 14.4662 16.2 12.9576V3.04237C16.2 1.53381 14.9916 0.3 13.5 0.3ZM6.05 14.2831H3.5C2.78647 14.2831 2.2 13.6915 2.2 12.9576V6.54746H6.05V14.2831ZM14.8 12.9576C14.8 13.6915 14.2135 14.2831 13.5 14.2831H7.45V6.54746H14.8V12.9576ZM14.8 5.13051H2.2V3.04237C2.2 2.30848 2.78647 1.71695 3.5 1.71695H13.5C14.2135 1.71695 14.8 2.30848 14.8 3.04237V5.13051Z"
        fill="#6366F1"
        stroke="#6366F1"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export const CloseUncoveredIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0002 0.832031C4.93755 0.832031 0.833496 4.93609 0.833496 9.9987C0.833496 15.0613 4.93755 19.1654 10.0002 19.1654C15.0628 19.1654 19.1668 15.0613 19.1668 9.9987C19.1668 4.93609 15.0628 0.832031 10.0002 0.832031ZM13.0894 6.90944C13.4149 7.23488 13.4149 7.76252 13.0894 8.08795L11.1787 9.9987L13.0894 11.9094C13.4149 12.2349 13.4149 12.7625 13.0894 13.088C12.764 13.4134 12.2363 13.4134 11.9109 13.088L10.0002 11.1772L8.08942 13.088C7.76398 13.4134 7.23634 13.4134 6.91091 13.088C6.58547 12.7625 6.58547 12.2349 6.91091 11.9094L8.82165 9.9987L6.91091 8.08795C6.58547 7.76252 6.58547 7.23488 6.91091 6.90944C7.23634 6.584 7.76398 6.584 8.08942 6.90944L10.0002 8.82019L11.9109 6.90944C12.2363 6.584 12.764 6.584 13.0894 6.90944Z"
        fill="#6C737F"
      />
    </svg>
  );
};

export const UncoveredDayIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 12.5013H12.5M17.5 6.66797H2.5M13.3333 1.66797V4.16797M6.66667 1.66797V4.16797M6.5 18.3346H13.5C14.9001 18.3346 15.6002 18.3346 16.135 18.0622C16.6054 17.8225 16.9878 17.44 17.2275 16.9696C17.5 16.4348 17.5 15.7348 17.5 14.3346V7.33464C17.5 5.9345 17.5 5.23444 17.2275 4.69966C16.9878 4.22925 16.6054 3.8468 16.135 3.60712C15.6002 3.33464 14.9001 3.33464 13.5 3.33464H6.5C5.09987 3.33464 4.3998 3.33464 3.86502 3.60712C3.39462 3.8468 3.01217 4.22925 2.77248 4.69966C2.5 5.23444 2.5 5.9345 2.5 7.33464V14.3346C2.5 15.7348 2.5 16.4348 2.77248 16.9696C3.01217 17.44 3.39462 17.8225 3.86502 18.0622C4.3998 18.3346 5.09987 18.3346 6.5 18.3346Z"
      stroke="#B42318"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SquareCloseIcon = () => (
  <svg
    width="16"
    height="20"
    style={{ margin: '0 2px' }}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66683 1.89258V5.3347C9.66683 5.80141 9.66683 6.03476 9.75766 6.21302C9.83755 6.36982 9.96504 6.49731 10.1218 6.5772C10.3001 6.66803 10.5335 6.66803 11.0002 6.66803H14.4423M5.91683 10.0013L10.0835 14.168M10.0835 10.0013L5.91683 14.168M9.66683 1.66797H5.3335C3.93336 1.66797 3.2333 1.66797 2.69852 1.94045C2.22811 2.18014 1.84566 2.56259 1.60598 3.03299C1.3335 3.56777 1.3335 4.26784 1.3335 5.66797V14.3346C1.3335 15.7348 1.3335 16.4348 1.60598 16.9696C1.84566 17.44 2.22811 17.8225 2.69852 18.0622C3.2333 18.3346 3.93336 18.3346 5.3335 18.3346H10.6668C12.067 18.3346 12.767 18.3346 13.3018 18.0622C13.7722 17.8225 14.1547 17.44 14.3943 16.9696C14.6668 16.4348 14.6668 15.7348 14.6668 14.3346V6.66797L9.66683 1.66797Z"
      stroke="#6C737F"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DischargeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9.84998 12.0022C10.0262 11.5014 10.3739 11.079 10.8317 10.81C11.2895 10.5409 11.8277 10.4426 12.351 10.5324C12.8743 10.6221 13.349 10.8942 13.6909 11.3004C14.0329 11.7066 14.22 12.2207 14.2192 12.7517C14.2192 14.2506 11.9709 15 11.9709 15M12 18H12.01M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
      stroke="#6C737F"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyPasteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M5 5.5V3.4C5 2.55992 5 2.13988 5.16349 1.81901C5.3073 1.53677 5.53677 1.3073 5.81901 1.16349C6.13988 1 6.55992 1 7.4 1H13.1C13.9401 1 14.3601 1 14.681 1.16349C14.9632 1.3073 15.1927 1.53677 15.3365 1.81901C15.5 2.13988 15.5 2.55992 15.5 3.4V9.1C15.5 9.94008 15.5 10.3601 15.3365 10.681C15.1927 10.9632 14.9632 11.1927 14.681 11.3365C14.3601 11.5 13.9401 11.5 13.1 11.5H11M2.9 16H8.6C9.44008 16 9.86012 16 10.181 15.8365C10.4632 15.6927 10.6927 15.4632 10.8365 15.181C11 14.8601 11 14.4401 11 13.6V7.9C11 7.05992 11 6.63988 10.8365 6.31901C10.6927 6.03677 10.4632 5.8073 10.181 5.66349C9.86012 5.5 9.44008 5.5 8.6 5.5H2.9C2.05992 5.5 1.63988 5.5 1.31901 5.66349C1.03677 5.8073 0.8073 6.03677 0.66349 6.31901C0.5 6.63988 0.5 7.05992 0.5 7.9V13.6C0.5 14.4401 0.5 14.8601 0.66349 15.181C0.8073 15.4632 1.03677 15.6927 1.31901 15.8365C1.63988 16 2.05992 16 2.9 16Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TemplatePasteIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 45111285">
        <g id="Group 45111284">
          <path
            id="Vector 1149"
            d="M14.5 6.5C14.5 6.77614 14.7239 7 15 7C15.2761 7 15.5 6.77614 15.5 6.5H14.5ZM15 3L15.5 3V3L15 3ZM3 15L3 14.5H3V15ZM15.3536 15.3536C15.5488 15.1583 15.5488 14.8417 15.3536 14.6464L12.1716 11.4645C11.9763 11.2692 11.6597 11.2692 11.4645 11.4645C11.2692 11.6597 11.2692 11.9763 11.4645 12.1716L14.2929 15L11.4645 17.8284C11.2692 18.0237 11.2692 18.3403 11.4645 18.5355C11.6597 18.7308 11.9763 18.7308 12.1716 18.5355L15.3536 15.3536ZM15.5 6.5L15.5 3L14.5 3L14.5 6.5H15.5ZM13 0.5H3V1.5H13V0.5ZM0.5 3V13H1.5V3H0.5ZM3 15.5L15 15.5V14.5L3 14.5L3 15.5ZM0.5 13C0.5 14.3807 1.61929 15.5 3 15.5V14.5C2.17157 14.5 1.5 13.8284 1.5 13H0.5ZM3 0.5C1.61929 0.5 0.5 1.61929 0.5 3H1.5C1.5 2.17157 2.17157 1.5 3 1.5V0.5ZM15.5 3C15.5 1.61929 14.3807 0.5 13 0.5V1.5C13.8284 1.5 14.5 2.17157 14.5 3L15.5 3Z"
            fill="white"
          />
          <path
            id="Vector 1151"
            d="M7 13.5V10C7 8.89543 7.89543 8 9 8H19C20.1046 8 21 8.89543 21 10V20C21 21.1046 20.1046 22 19 22H9C7.89543 22 7 21.1046 7 20V16.5556"
            stroke="white"
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const WeeklyCopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="18"
      viewBox="0 0 36 18"
      fill="none"
    >
      <path
        d="M13.3167 0.6C15.2929 0.6 16.9 2.20709 16.9 4.18333V13.8167C16.9 15.7929 15.2929 17.4 13.3167 17.4H10.4833C10.071 17.4 9.73333 17.0623 9.73333 16.65C9.73333 16.2377 10.071 15.9 10.4833 15.9H13.3167C14.4656 15.9 15.4 14.9656 15.4 13.8167V4.18333C15.4 3.03444 14.4656 2.1 13.3167 2.1H3.68333C2.53444 2.1 1.6 3.03444 1.6 4.18333V7.01667C1.6 7.42896 1.2623 7.76667 0.85 7.76667C0.437705 7.76667 0.1 7.42896 0.1 7.01667V4.18333C0.1 2.20709 1.70709 0.6 3.68333 0.6H13.3167Z"
        fill="#6C737F"
        stroke="white"
        strokeWidth="0.2"
      />
      <path
        d="M3.69452 14.3571V14.2571H3.59452H1.3088C0.892579 14.2571 0.55166 13.9162 0.55166 13.5C0.55166 13.0838 0.892579 12.7429 1.3088 12.7429H3.59452H3.69452V12.6429V10.3571C3.69452 9.94092 4.03544 9.6 4.45166 9.6C4.86788 9.6 5.2088 9.94092 5.2088 10.3571V12.6429V12.7429H5.3088H7.59452C8.01074 12.7429 8.35166 13.0838 8.35166 13.5C8.35166 13.9162 8.01074 14.2571 7.59452 14.2571H5.3088H5.2088V14.3571V16.6429C5.2088 17.0591 4.86788 17.4 4.45166 17.4C4.03544 17.4 3.69452 17.0591 3.69452 16.6429V14.3571Z"
        fill="#6C737F"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const CopySelectedTempIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="18"
      viewBox="0 0 36 18"
      fill="none"
    >
      <path
        d="M14.1667 0.5H2.83333C1.27167 0.5 0 1.79322 0 3.38136V14.6186C0 16.2068 1.27167 17.5 2.83333 17.5H14.1667C15.7283 17.5 17 16.2068 17 14.6186V3.38136C17 1.79322 15.7283 0.5 14.1667 0.5ZM5.95 16.3475H2.83333C1.8959 16.3475 1.13333 15.572 1.13333 14.6186V7.12712H5.95V16.3475ZM15.8667 14.6186C15.8667 15.572 15.1041 16.3475 14.1667 16.3475H7.08333V7.12712H15.8667V14.6186ZM15.8667 5.97458H1.13333V3.38136C1.13333 2.42804 1.8959 1.65254 2.83333 1.65254H14.1667C15.1041 1.65254 15.8667 2.42804 15.8667 3.38136V5.97458Z"
        fill="#6C737F"
      />
    </svg>
  );
};

export const WarningIconTherapyTemplate = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M9 5.8V9M9 12.2H9.008M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
        stroke="#6366F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddNoteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.833 9.25H6.33301M7.83301 12.25H6.33301M12.333 6.25H6.33301M15.333 6.1V13.9C15.333 15.1601 15.333 15.7902 15.0878 16.2715C14.8721 16.6948 14.5279 17.039 14.1045 17.2548C13.6232 17.5 12.9931 17.5 11.733 17.5H6.93301C5.67289 17.5 5.04283 17.5 4.56153 17.2548C4.13816 17.039 3.79396 16.6948 3.57824 16.2715C3.33301 15.7902 3.33301 15.1601 3.33301 13.9V6.1C3.33301 4.83988 3.33301 4.20982 3.57824 3.72852C3.79396 3.30516 4.13816 2.96095 4.56153 2.74524C5.04283 2.5 5.67289 2.5 6.93301 2.5H11.733C12.9931 2.5 13.6232 2.5 14.1045 2.74524C14.5279 2.96095 14.8721 3.30516 15.0878 3.72852C15.333 4.20982 15.333 4.83988 15.333 6.1Z"
        stroke="#6C737F"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.5302 5.70129V4.9954C14.5302 4.00708 14.5302 3.51291 14.3378 3.13542C14.1686 2.80337 13.8987 2.5334 13.5666 2.36422C13.1891 2.17188 12.695 2.17188 11.7066 2.17188H10.2949C9.30654 2.17188 8.81237 2.17188 8.43488 2.36422C8.10283 2.5334 7.83286 2.80337 7.66368 3.13542C7.47133 3.51291 7.47133 4.00708 7.47133 4.9954V5.70129M9.23604 10.5542V14.966M12.7655 10.5542V14.966M3.05957 5.70129H18.9419M17.1772 5.70129V15.5836C17.1772 17.0661 17.1772 17.8074 16.8887 18.3736C16.6349 18.8717 16.23 19.2766 15.7319 19.5304C15.1657 19.8189 14.4244 19.8189 12.9419 19.8189H9.05957C7.57708 19.8189 6.83583 19.8189 6.2696 19.5304C5.77152 19.2766 5.36657 18.8717 5.11279 18.3736C4.82428 17.8074 4.82428 17.0661 4.82428 15.5836V5.70129"
        stroke="#F04438"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MergeMdsAssessment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 6.66406H2.5M13.3333 1.66406V4.16406M6.66667 1.66406V4.16406M6.5 18.3307H13.5C14.9001 18.3307 15.6002 18.3307 16.135 18.0582C16.6054 17.8186 16.9878 17.4361 17.2275 16.9657C17.5 16.4309 17.5 15.7309 17.5 14.3307V7.33073C17.5 5.9306 17.5 5.23053 17.2275 4.69575C16.9878 4.22535 16.6054 3.8429 16.135 3.60321C15.6002 3.33073 14.9001 3.33073 13.5 3.33073H6.5C5.09987 3.33073 4.3998 3.33073 3.86502 3.60321C3.39462 3.8429 3.01217 4.22535 2.77248 4.69575C2.5 5.23053 2.5 5.9306 2.5 7.33073V14.3307C2.5 15.7309 2.5 16.4309 2.77248 16.9657C3.01217 17.4361 3.39462 17.8186 3.86502 18.0582C4.3998 18.3307 5.09987 18.3307 6.5 18.3307Z"
        stroke="#6C737F"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(6, 8.9) scale(.8)">
        <path
          d="M1.86316 1.86376C0.4457 3.28076 0.445697 5.57966 1.86265 6.99662L1.86273 6.99669C3.28114 8.41354 5.57847 8.41354 6.99684 6.99669L6.99689 6.99664C8.41435 5.57965 8.41435 3.28074 6.9974 1.86379L6.85597 2.00521L6.99739 1.86379C5.57897 0.445406 3.28154 0.44538 1.86316 1.86376ZM1.86316 1.86376L2.00455 2.00521L1.86316 1.86376ZM3.14701 4.5811L3.14702 4.58111L3.81146 5.36581C3.81158 5.36596 3.81171 5.36611 3.81183 5.36626C3.9687 5.55294 4.24556 5.57323 4.43053 5.41779L4.43934 5.41038L4.44725 5.40201L5.69785 4.07804L5.69823 4.07764C5.78994 3.98001 5.82988 3.86016 5.81837 3.74109C5.80737 3.62715 5.75094 3.52855 5.67681 3.45891C5.60269 3.38927 5.50077 3.33909 5.38638 3.33526C5.26694 3.33127 5.15002 3.37864 5.05859 3.4762C5.05848 3.47632 5.05836 3.47645 5.05825 3.47657L4.16425 4.42373L3.81679 4.01293L3.81665 4.01276C3.73013 3.9107 3.61562 3.85769 3.49621 3.85572C3.38196 3.85384 3.27771 3.89865 3.20013 3.96436C3.12254 4.03007 3.06109 4.12561 3.04427 4.23888C3.02669 4.35723 3.06051 4.47891 3.14701 4.5811ZM1.67997 4.43008C1.67997 2.91064 2.91149 1.67917 4.42945 1.67917C5.94835 1.67917 7.18036 2.91065 7.18036 4.43008C7.18036 5.94796 5.94896 7.17956 4.42945 7.17956C2.91144 7.17956 1.67997 5.94946 1.67997 4.43008Z"
          fill="#6C737F"
          stroke="#6C737F"
          strokeWidth="0.4"
        />
        <path
          d="M9.04138 8.52609C9.32857 8.74148 9.73599 8.68328 9.95138 8.39609C10.1668 8.10891 10.1086 7.70148 9.82138 7.48609L9.04138 8.52609ZM6.89784 6.91844L9.04138 8.52609L9.82138 7.48609L7.67784 5.87844L6.89784 6.91844Z"
          fill="#6C737F"
        />
      </g>
    </svg>
  );
};

export const MergeMdsAssessmentColor = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 6.66406H2.5M13.3333 1.66406V4.16406M6.66667 1.66406V4.16406M6.5 18.3307H13.5C14.9001 18.3307 15.6002 18.3307 16.135 18.0582C16.6054 17.8186 16.9878 17.4361 17.2275 16.9657C17.5 16.4309 17.5 15.7309 17.5 14.3307V7.33073C17.5 5.9306 17.5 5.23053 17.2275 4.69575C16.9878 4.22535 16.6054 3.8429 16.135 3.60321C15.6002 3.33073 14.9001 3.33073 13.5 3.33073H6.5C5.09987 3.33073 4.3998 3.33073 3.86502 3.60321C3.39462 3.8429 3.01217 4.22535 2.77248 4.69575C2.5 5.23053 2.5 5.9306 2.5 7.33073V14.3307C2.5 15.7309 2.5 16.4309 2.77248 16.9657C3.01217 17.4361 3.39462 17.8186 3.86502 18.0582C4.3998 18.3307 5.09987 18.3307 6.5 18.3307Z"
        stroke="#107569"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g transform="translate(6, 8.9) scale(.8)">
        <path
          d="M1.86316 1.86376C0.4457 3.28076 0.445697 5.57966 1.86265 6.99662L1.86273 6.99669C3.28114 8.41354 5.57847 8.41354 6.99684 6.99669L6.99689 6.99664C8.41435 5.57965 8.41435 3.28074 6.9974 1.86379L6.85597 2.00521L6.99739 1.86379C5.57897 0.445406 3.28154 0.44538 1.86316 1.86376ZM1.86316 1.86376L2.00455 2.00521L1.86316 1.86376ZM3.14701 4.5811L3.14702 4.58111L3.81146 5.36581C3.81158 5.36596 3.81171 5.36611 3.81183 5.36626C3.9687 5.55294 4.24556 5.57323 4.43053 5.41779L4.43934 5.41038L4.44725 5.40201L5.69785 4.07804L5.69823 4.07764C5.78994 3.98001 5.82988 3.86016 5.81837 3.74109C5.80737 3.62715 5.75094 3.52855 5.67681 3.45891C5.60269 3.38927 5.50077 3.33909 5.38638 3.33526C5.26694 3.33127 5.15002 3.37864 5.05859 3.4762C5.05848 3.47632 5.05836 3.47645 5.05825 3.47657L4.16425 4.42373L3.81679 4.01293L3.81665 4.01276C3.73013 3.9107 3.61562 3.85769 3.49621 3.85572C3.38196 3.85384 3.27771 3.89865 3.20013 3.96436C3.12254 4.03007 3.06109 4.12561 3.04427 4.23888C3.02669 4.35723 3.06051 4.47891 3.14701 4.5811ZM1.67997 4.43008C1.67997 2.91064 2.91149 1.67917 4.42945 1.67917C5.94835 1.67917 7.18036 2.91065 7.18036 4.43008C7.18036 5.94796 5.94896 7.17956 4.42945 7.17956C2.91144 7.17956 1.67997 5.94946 1.67997 4.43008Z"
          fill="#107569"
          stroke="#107569"
          strokeWidth="0.4"
        />
        <path
          d="M9.04138 8.52609C9.32857 8.74148 9.73599 8.68328 9.95138 8.39609C10.1668 8.10891 10.1086 7.70148 9.82138 7.48609L9.04138 8.52609ZM6.89784 6.91844L9.04138 8.52609L9.82138 7.48609L7.67784 5.87844L6.89784 6.91844Z"
          fill="#107569"
          stroke="#107569"
        />
      </g>
    </svg>
  );
};
